import { Trans, useTranslation } from "react-i18next";
import { cn } from "../../../../utils/classnames";
import { createTypographyHelper } from "../../../../utils/typography";

const TheLuxuryFleetLogo = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/about/the-luxury-fleet-logo.png";
const TheLuxuryFleetCorporateInformationImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/about/the-luxury-fleet-corporate-information.png";
const TheLuxuryFleetContactImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/about/the-luxury-fleet-contact.png";
export const TheLuxuryFleetDetail = () => {
  const { t, i18n } = useTranslation();
  const getTypographyClass = createTypographyHelper(i18n.language);
  return (
    <div className="tw:px-5 tw:lg:px-[82px] tw:mt-8 tw:lg:mt-[54px]">
      <div className="tw:bg-[#54162A] tw:rounded-[10px] tw:px-[22px] tw:py-7 tw:lg:px-[54px] tw:lg:py-[54px] tw:flex tw:justify-between tw:items-start tw:lg:items-center">
        <div className="tw:lg:flex-1">
          <div className="tw:text-[#FFF8E8] tw:text-[8px] tw:tracking-[3px] tw:font-semibold tw:font-hanken-grotesk tw:leading-none tw:uppercase">
            {t("Corporate.Profile")}
          </div>
          <div className="tw:font-libre-caslon-display tw:text-[#DBBE78] tw:text-[26px] tw:lg:text-[34px] tw:leading-[35px] tw:lg:leading-[45px] tw:mt-[10px] tw:lg:mt-3">
            {t("AboutPage.LuxuryFleet.Title")}
          </div>
          <div className="tw:h-[1px] tw:bg-[#E4D6B3] tw:w-[88px] tw:my-4 tw:lg:my-7" />
          <div
            className={cn(
              "tw:text-[#FFF8E8] tw:font-hanken-grotesk",
              getTypographyClass(12),
              getTypographyClass(13, "lg")
            )}
          >
            <Trans
              className={cn(
                "tw:text-[#FFF8E8] tw:font-hanken-grotesk",
                getTypographyClass(12),
                getTypographyClass(13, "lg")
              )}
              i18nKey={`AboutPage.LuxuryFleet.Description`}
              components={{
                strong: (
                  <strong></strong>
                ),
              }}
            />
          </div>
        </div>
        <div className="tw:lg:flex-1 tw:flex tw:items-start tw:lg:justify-end">
          <img
            src={TheLuxuryFleetLogo}
            alt="logo"
            className="tw:min-w-[80px] tw:lg:min-w-[135px] tw:w-[80px] tw:lg:w-[135px]"
          />
        </div>
      </div>

      {/* Divider */}
      <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-8 tw:lg:my-[54px]" />

      {/* About */}
      <div className="tw:font-hanken-grotesk tw:text-[#282828] tw:flex tw:flex-col tw:lg:flex-row">
        <div className="tw:font-medium tw:lg:font-semibold tw:lg:text-[18px] tw:lg:leading-[25px] tw:lg:min-w-[354px]">
          {t("AboutPage.LuxuryFleet.About.Label")}
        </div>
        <div
          className={cn(
            "tw:mt-5 tw:lg:mt-0",
            getTypographyClass(13),
            getTypographyClass(14, "lg")
          )}
        >
          <Trans
            i18nKey={"AboutPage.LuxuryFleet.About.Description"}
            components={{
              strong: <strong></strong>,
            }}
          />
        </div>
      </div>

      {/* Divider */}
      <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-8 tw:lg:my-[54px]" />

      {/* Corporate Information */}
      <div className="tw:font-hanken-grotesk tw:text-[#282828] tw:flex tw:flex-col tw:lg:flex-row">
        <div className="tw:font-medium tw:lg:font-semibold tw:lg:text-[18px] tw:lg:leading-[25px] tw:lg:min-w-[354px]">
          {t("AboutPage.LuxuryFleet.CorporateInformation.Label")}
        </div>
        <div className="tw:flex tw:flex-col tw:xl:flex-row tw:flex-col-reverse tw:w-full tw:gap-x-[45px]">
          <div>
            <div className="tw:font-libre-caslon-display tw:mt-8 tw:xl:mt-0 tw:text-[22px] tw:lg:text-[26px] tw:leading-[26px] tw:lg:leading-[35px]">
              {t("AboutPage.LuxuryFleet.CorporateInformation.CorporateName")}
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:mt-6 tw:lg:mt-8 tw:mb-6 tw:lg:mb-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.LuxuryFleet.CorporateInformation.RegistrationNumber.Label")}
              </div>
              <div
                className={cn(
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.LuxuryFleet.CorporateInformation.RegistrationNumber.Value"}
                  components={{
                    strong: <strong></strong>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.LuxuryFleet.CorporateInformation.MembershipRecord.Label")}
              </div>
              <div
                className={cn(
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.LuxuryFleet.CorporateInformation.MembershipRecord.Value"}
                  components={{
                    strong: <strong></strong>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.LuxuryFleet.CorporateInformation.Services.Label")}
              </div>
              <div
                className={cn(
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.LuxuryFleet.CorporateInformation.Services.Value"}
                  components={{
                    strong: <strong></strong>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.LuxuryFleet.CorporateInformation.Address.Label")}
              </div>
              <div
                className={cn(
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.LuxuryFleet.CorporateInformation.Address.Value"}
                  components={{
                    strong: <strong></strong>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.LuxuryFleet.CorporateInformation.CEO.Label")}
              </div>
              <div
                className={cn(
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.LuxuryFleet.CorporateInformation.CEO.Value"}
                  components={{
                    strong: <strong></strong>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.LuxuryFleet.CorporateInformation.DateOfEstablishment.Label")}
              </div>
              <div
                className={cn(
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.LuxuryFleet.CorporateInformation.DateOfEstablishment.Value"}
                  components={{
                    strong: <strong></strong>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.LuxuryFleet.CorporateInformation.Capital.Label")}
              </div>
              <div
                className={cn(
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.LuxuryFleet.CorporateInformation.Capital.Value"}
                  components={{
                    strong: <strong></strong>,
                  }}
                />
              </div>
            </div>
          </div>
          <div className="tw:flex tw:flex-1 tw:justify-center tw:2xl:justify-end tw:mt-5 tw:lg:mt-0">
            <img
              src={TheLuxuryFleetCorporateInformationImage}
              alt="The Luxury Fleet Coporate Information"
              className="tw:h-[200px] tw:sm:h-[400px] tw:lg:h-full tw:lg:min-w-[260px] tw:w-full tw:xl:w-[260px] tw:object-cover tw:rounded-[5px] tw:object-bottom"
            />
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-8 tw:lg:my-[54px]" />

      {/* Contact */}
      <div className="tw:font-hanken-grotesk tw:text-[#282828] tw:flex tw:flex-col tw:lg:flex-row">
        <div className="tw:font-medium tw:lg:font-semibold tw:lg:text-[18px] tw:lg:leading-[25px] tw:lg:min-w-[354px]">
          {t("AboutPage.LuxuryFleet.Contact.Label")}
        </div>
        <div className="tw:flex tw:gap-x-[45px] tw:gap-y-8 tw:flex-col tw:xl:flex-row tw:w-full tw:mt-5 tw:lg:mt-0">
          <div>
            <img
              src={TheLuxuryFleetContactImage}
              alt="The Luxury Fleet Contact"
              className="tw:h-[200px] tw:sm:h-[400px] tw:lg:h-full tw:lg:min-w-[260px] tw:w-full tw:xl:w-[260px] tw:object-cover tw:rounded-[5px] tw:object-bottom"
            />
          </div>
          <div
            className={cn(
              "tw:mt-5 tw:lg:mt-0 tw:flex-1",
              getTypographyClass(13),
              getTypographyClass(14, "lg")
            )}
          >
            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.LuxuryFleet.Contact.PhoneNumber.Label")}
              </div>
              <div
                className={cn(
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.LuxuryFleet.Contact.PhoneNumber.Value"}
                  components={{
                    strong: <strong></strong>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.LuxuryFleet.Contact.WhatsAppBusiness.Label")}
              </div>
              <div
                className={cn(
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.LuxuryFleet.Contact.WhatsAppBusiness.Value"}
                  components={{
                    u: <u></u>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.LuxuryFleet.Contact.Email.Label")}
              </div>
              <div
                className={cn(
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.LuxuryFleet.Contact.Email.Value"}
                  components={{
                    strong: <strong></strong>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.LuxuryFleet.Contact.LINEOfficialAccount.Label")}
              </div>
              <div
                className={cn(
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.LuxuryFleet.Contact.LINEOfficialAccount.Value"}
                  components={{
                    u: <u></u>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.LuxuryFleet.Contact.Instagram.Label")}
              </div>
              <div
                className={cn(
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.LuxuryFleet.Contact.Instagram.Value"}
                  components={{
                    u: <u></u>,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};